// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 6388) return "static/chunks/6388.6b13017a2e250117.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"2179":"097609360d313688","2235":"84eb4c059a86de17"}[chunkId] + ".js";
};